import React from 'react';

// Function to detect URLs and convert them to clickable links
export const LinkifyText = ({ text }) => {
  if (!text) return null;

  // Regex to match URLs
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  
  // Split text by URLs
  const parts = text.split(urlRegex);
  
  return (
    <>
      {parts.map((part, index) => {
        // Check if this part is a URL
        if (part.match(urlRegex)) {
          return (
            <a
              key={index}
              href={part}
              target="_blank"
              rel="noopener noreferrer"
              className="text-green-600 hover:text-green-700 underline font-medium"
            >
              {part}
            </a>
          );
        }
        // Regular text - preserve line breaks
        return <span key={index} className="whitespace-pre-line">{part}</span>;
      })}
    </>
  );
};

// Alternative: Linkify with email support
export const LinkifyTextWithEmail = ({ text }) => {
  if (!text) return null;

  // Regex to match URLs and emails
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  const emailRegex = /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/g;
  
  // Combined regex
  const combinedRegex = /(https?:\/\/[^\s]+|[a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/g;
  
  const parts = text.split(combinedRegex);
  
  return (
    <>
      {parts.map((part, index) => {
        // Check if this part is a URL
        if (part.match(urlRegex)) {
          return (
            <a
              key={index}
              href={part}
              target="_blank"
              rel="noopener noreferrer"
              className="text-green-600 hover:text-green-700 underline font-medium"
            >
              {part}
            </a>
          );
        }
        // Check if this part is an email
        if (part.match(emailRegex)) {
          return (
            <a
              key={index}
              href={`mailto:${part}`}
              className="text-green-600 hover:text-green-700 underline font-medium"
            >
              {part}
            </a>
          );
        }
        // Regular text - preserve line breaks
        return <span key={index} className="whitespace-pre-line">{part}</span>;
      })}
    </>
  );
};
